import { CoreFetch, ProviderClaimResponsibilityReportItem, ReportApi } from '@enter/core';
import { fetch } from './util';

export class ClaimResponsibilityService {
    /**
     * Active claims grouped by (responsibility type, responsibility category), with a distinct-claim
     * count and summed charges per pair — the "Active Claims By Responsibility" widget (FE-151).
     *
     * - filters `Claim.CreateDate` in `[start, end)`: `start` inclusive, `end` EXCLUSIVE. Build the
     *   params with `toResponsibilityReportParams` rather than by hand;
     * - 400s when either date is missing, `end <= start`, or the range is over one calendar year;
     * - only `Active = 1` claims, of every claim type — there is no claim-type parameter;
     * - responsibility is the claim's CURRENT state, not its state on the create date;
     * - an empty array means no claims, not a failure.
     */
    public fetchReport = async (params: { start: string; end: string }): Promise<ProviderClaimResponsibilityReportItem[] | undefined> => {
        return fetch(params, async req => CoreFetch<ReportApi>(ReportApi).getClaimResponsibilityReport(req));
    };
}
